import { RoleDTO } from "../roles/Role";
import { Account, AccountDTO, AccountRelatedDTO } from "./Account";
import { AccountUserGroupDTO } from "../account-user-group/AccountUserGroup";

export interface AccountUserDTO {
  account: AccountDTO;
  account_id: number;
  groups?: AccountUserGroupDTO[];
  id: number;
  preferences: any;
  profile: any;
  restrict_to_facilities: number[] | null;
  role: RoleDTO;
  role_id: number;
  user_id: number;
  send_internal_mail: boolean;
}

export class AccountUser {
  private _account: Account;
  constructor(
    private _accountUserDTO: AccountUserDTO,
    _accountRelatedDTO?: AccountRelatedDTO,
  ) {
    this._account = new Account(_accountUserDTO.account, _accountRelatedDTO);
  }

  get account() {
    return this._account;
  }

  get account_id() {
    return this._accountUserDTO.account_id;
  }

  get id() {
    return this._accountUserDTO.id;
  }

  get preferences() {
    return this._accountUserDTO.preferences;
  }

  get profile() {
    return this._accountUserDTO.profile;
  }

  get restrictToFacilities() {
    return this._accountUserDTO.restrict_to_facilities;
  }

  set restrictToFacilities(restrictToFacilities: number[] | null) {
    this._accountUserDTO.restrict_to_facilities = restrictToFacilities;
  }

  get role() {
    return this._accountUserDTO.role;
  }

  get role_id() {
    return this._accountUserDTO.role_id;
  }

  get user_id() {
    return this._accountUserDTO.user_id;
  }

  get groups() {
    return this._accountUserDTO.groups;
  }

  set groups(groups: AccountUserGroupDTO[] | undefined) {
    this._accountUserDTO.groups = groups;
  }

  get accountUserDTO() {
    return this._accountUserDTO;
  }

  set accountUserDTO(value: AccountUserDTO) {
    this._accountUserDTO = value;
  }

  get accountDTO() {
    return this._account;
  }

  get send_internal_mail() {
    return this._accountUserDTO.send_internal_mail;
  }
}
